import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { BillingInfo, GetOrganizationParams, GetOrganizationOptions } from '@nx-frontend/shared/types';
import { decideLogLevelForError, logger } from '@nx-frontend/shared/utils';

interface GetBillingInfoOptions extends GetOrganizationOptions {
  useSecret: boolean; // use this option as "true" only for ssr
}

export async function getBillingInfo(
  { globalId }: GetOrganizationParams,
  { userId, useSecret = false }: GetBillingInfoOptions
): Promise<BillingInfo | null> {
  let billingInfo: BillingInfo | null = null;

  try {
    const headers: Record<string, string> = {};
    if (useSecret) {
      headers['x-secret'] = generalEnv.superSecret;
    } else {
      headers['Authorization'] = `internal ${userId}:auto`;
    }
    const response = await axiosClient.get<BillingInfo>(`${generalEnv.orgServiceUrl}/v1/orgs/${globalId}/billingInfo`, {
      headers,
    });
    billingInfo = response.data;
  } catch (err) {
    logger[decideLogLevelForError(err)](`getBillingInfo error: %j`, err);
  }

  return billingInfo;
}
